//获取cookie

function getCookie(cname) {
    var name = cname + "=";
    console.log("document",document)
    var ca = document.cookie.split(';');
    console.log("获取cookie,现在循环",ca)
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        console.log(c)
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) != -1){
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
export default getCookie;
